import {useCallback, useState} from "react";

import useDialog from "../../../hooks/useDialog";

const useEmailProvidersActions = () => {
    const [selectedProvider, setSelectedProvider] = useState({});
    const formCreate = useDialog();
    const formEdit = useDialog();

    const handleEditAccount = useCallback(
        (account) => {
            setSelectedProvider(account);
            formEdit.open();
        },
        [formEdit]
    )

    return {
        formCreate,
        formEdit,
        selectedProvider,
        handleEditAccount,
    }
}

export default useEmailProvidersActions;